export default {
  'Enter a promo code! First limit people receive amount coins':
    '¡Introduce un código promocional! El primer límite de gente recibe una cantidad de monedas',
};
